var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "insidaPlanContent",
      on: { click: _vm.closeInsidePlanMenu }
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "spinner-overlay" },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container mr-4" },
        [
          _c("technical-local-summary", {
            attrs: {
              phase: _vm.techLocal.tl_status,
              "network-level": _vm.techLocal.tl_network_level,
              "cables-in": _vm.techLocal.cable_in,
              "cables-out": _vm.techLocal.cable_out
            },
            on: {
              "set-tech-uuid": function($event) {
                _vm.techLocalUuid = $event
              }
            }
          }),
          _vm._v(" "),
          _c("inside-plan-diagram", {
            attrs: {
              racks: _vm.formattedRacks,
              disabled: !!!_vm.techLocal.tl_id
            },
            on: {
              "open-form": _vm.openForm,
              "open-menu": _vm.openMenu,
              "open-rack-menu": _vm.openRackMenu,
              "set-active-position": _vm.setActivePosition,
              "start-drag": _vm.startDrag,
              "end-drag": _vm.endDrag,
              "save-drawer-changes": _vm.saveDrawerChanges
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container", staticStyle: { "overflow-y": "visible" } },
        [
          _c("selected-drawer", {
            key: _vm.selectedDrawerRefreshToken,
            attrs: {
              "selected-drawer": _vm.selectedDrawer,
              connections: _vm.selectedDrawerConnections,
              "connections-were-changed": _vm.connectionsWereChanged
            },
            on: {
              "open-tray-connection-menu": _vm.openTrayConnectionMenu,
              "open-tube-form": _vm.openAddTubeFiberForm,
              "open-cassette-form": _vm.openCassetteForm,
              "open-delete-cassette-dialog": _vm.openDeleteCassetteDialog,
              "save-changes": _vm.saveConnectionsChanges
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isFormOpen
        ? _c("rack-drawer-form", {
            attrs: {
              "dialog-is-open": _vm.isFormOpen,
              objectType: _vm.objectType,
              "item-to-edit": _vm.objectToEdit,
              action: _vm.action,
              "rack-options": _vm.rackMaterialsOptions,
              "drawer-options": _vm.drawerMaterialsOptions
            },
            on: {
              "add-rack": _vm.createRack,
              "edit-rack": _vm.editRack,
              "add-drawer": _vm.addDrawer,
              "edit-drawer": _vm.editDrawer,
              "close-rack-form": function($event) {
                _vm.isFormOpen = !_vm.isFormOpen
                _vm.itemToEdit = null
              }
            }
          })
        : _vm.isDrawerMenuOpen
        ? _c("drawer-options-menu", {
            attrs: {
              horizontal: _vm.menuHorizontalPostion,
              vertical: _vm.menuVerticalPosition,
              "is-empty-position": _vm.isEmptyPosition
            },
            on: { "open-form": _vm.openForm, "delete-drawer": _vm.deleteDrawer }
          })
        : _vm.isRackMenuOpen
        ? _c("rack-options-menu", {
            attrs: {
              horizontal: _vm.menuHorizontalPostion,
              vertical: _vm.menuVerticalPosition
            },
            on: { "open-form": _vm.openForm, "delete-rack": _vm.deleteRack }
          })
        : _vm.trayConnectionMenu.isOpen
        ? _c("tray-connection-menu", {
            attrs: {
              horizontal: _vm.menuHorizontalPostion,
              vertical: _vm.menuVerticalPosition
            },
            on: {
              "edit-fiber": function($event) {
                return _vm.openEditTubeFiberForm("fiber")
              },
              "edit-tube": function($event) {
                return _vm.openEditTubeFiberForm("tube")
              },
              "remove-fiber": function($event) {
                return _vm.openDeleteTubeFiberDialog("fiber")
              },
              "remove-tube": function($event) {
                return _vm.openDeleteTubeFiberDialog("tube")
              }
            }
          })
        : _vm.addTubeFiberForm.isOpen
        ? _c("add-tube-fiber-form", {
            attrs: {
              "dialog-is-open": _vm.addTubeFiberForm.isOpen,
              "available-fibers": _vm.availableFibers(
                _vm.techLocal.cable_in,
                _vm.techLocal.cable_out
              )
            },
            on: {
              "add-object": _vm.addTubeFiber,
              "close-form": _vm.closeAddTubeFiberForm
            }
          })
        : _vm.editTubeFiberForm.isOpen
        ? _c("edit-tube-fiber-form", {
            attrs: {
              "dialog-is-open": _vm.editTubeFiberForm.isOpen,
              "fiber-type-options": _vm.fiberTypeOptions,
              "object-data": _vm.editTubeFiberForm.fiberData,
              "object-type": _vm.editTubeFiberForm.objectTypeToEdit
            },
            on: {
              "edit-object": _vm.editTubeFiber,
              "close-form": _vm.closeEditTubeFiberForm
            }
          })
        : _vm.tubeFiberDialog.isOpen
        ? _c("delete-tube-fiber-dialog", {
            attrs: { "dialog-is-open": _vm.tubeFiberDialog.isOpen },
            on: {
              "cancel-delete": _vm.closeTubeFiberDialog,
              "confirm-delete": _vm.deleteTubeFiber
            }
          })
        : _vm.deleteCassetteDialog.isOpen
        ? _c("delete-cassette-dialog", {
            attrs: {
              "dialog-is-open": _vm.deleteCassetteDialog.isOpen,
              "cassette-label": _vm.deleteCassetteDialog.cassetteLabel
            },
            on: {
              "cancel-delete": _vm.closeDeleteCassetteDialog,
              "confirm-delete": _vm.confirmDeleteCassetteInInsidePlan
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cassetteForm.isOpen
        ? _c("add-or-edit-cassette-form", {
            attrs: {
              "dialog-is-open": _vm.cassetteForm.isOpen,
              "item-to-edit": _vm.objectToEdit,
              "cassette-options": _vm.cassetteMaterialsOptions
            },
            on: {
              "create-cassette": _vm.saveCassette,
              "edit-cassette": _vm.saveCassette,
              "close-cassette-form": _vm.closeCassetteForm
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33a3b344", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a3b344","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/InsidePlan.vue
// module id = null
// module chunks = 